import { format } from "date-fns";

/* Click log `source` for every event of the front desk direct overbooking flow */
export const FRONT_DESK_OB_LOG_SOURCE = "FRONT_DESK_OVERBOOKING";

/* Start times every 5 min grouped by hour, so that start + duration ends the same day.
   Today starts from the next 5 min multiple from now (11:43 -> 11:45), a future date from 00:00, a past date has none.
   e.g. { "11": ["45", "50", "55"], "12": ["00", ...] } */
export const getStartTimeOptions = (bookingDate: string, durationMinutes: number): Record<string, string[]> => {
  const options: Record<string, string[]> = {};
  const today = format(new Date(), "yyyy-MM-dd");
  if (!bookingDate || bookingDate < today || !durationMinutes || durationMinutes <= 0) return options;

  const now = new Date();
  const firstStart = bookingDate === today ? Math.ceil((now.getHours() * 60 + now.getMinutes()) / 5) * 5 : 0;
  const lastStart = 24 * 60 - 1 - durationMinutes;
  for (let start = firstStart; start <= lastStart; start += 5) {
    const hours = `${Math.floor(start / 60)}`.padStart(2, "0");
    options[hours] = [...(options[hours] ?? []), `${start % 60}`.padStart(2, "0")];
  }
  return options;
};
